"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  colors: {
    blue: '#1976D2',
    blueLight: '#CFF0FF',
    bluePastel: '#DDEAF8',
    grayLight: '#D6D6D6',
    grayLighter: '#E8E8E8',
    lavender: '#D9DFFD'
  }
};
exports["default"] = _default;